import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-items-form',
  templateUrl: './items-form.component.html',
  styleUrls: ['./items-form.component.css'],
})
export class ItemsFormComponent {
  url: string = 'invoice';
  form!: FormGroup;

  data: Array<any> = [];
  id!: string;
  isLoading: boolean = false;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private router: Router,
    private messageService: MessageService,
    private route: ActivatedRoute
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];

      if (this.id) {
        this.getData();
      }
    });
  }

  private initForm(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      rate: [0, [Validators.required]],
      description: ['', [Validators.required]],
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  back() {
    this.router.navigateByUrl('billing/invoices/items');
  }

  getData(): void {
    this.isLoading = true;
    console.log('gen invoice getData', this.id);
    this.dataService.getData(`${this.url}/items/list/${this.id}`).subscribe((response) => {
      console.log('response getData', response);
      this.form.patchValue({
        name: response.data.name,
        rate: response.data.rate,
        description: response.data.description,
      });
      this.isLoading = false;
    });
  }

  createData() {
    this.isLoading = true;
    console.log('invoice createItem');
    this.dataService
      .postData(`${this.url}/createItem`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del servidor createInvoice: ', response);
          if (response && response.rst === true) {
            this.form.reset();
            this.isLoading = false;
            this.router.navigateByUrl('/billing/invoices/items');
          } else {
          }
        },
        error: (error) => {
          console.error('Error al crear:', error);
          // this.messageService.add('Error al crear el : ' + (error.error?.msg || error.message), 'danger');
        },
      });
  }

  updateData(): void {
    this.isLoading = true;
    console.log('gen invoice');
    this.dataService
      .putData(`${this.url}/items/edit/${this.id}`, this.form.value)
      .subscribe({
        next: (response: any) => {
          console.log('Respuesta del servidor update invoice: ', response);
          if (response && response.rst === true) {
            this.form.reset();
            this.isLoading = false;
            this.router.navigateByUrl('/billing/invoices/items');
          } else {
          }
        },
        error: (error) => {
          console.error('Error al crear:', error);
          // this.messageService.add('Error al crear el : ' + (error.error?.msg || error.message), 'danger');
        },
      });
  }
}
